module.exports = __webpack_public_path__ + "static/chamur-0eb0d9aff8e0e965879cd9c3b8bd9e4f.png";